var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeSection'),_c('RegisterSection'),_c('ArticlesSection'),_c('NewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }